import { safeLocalStorage } from 'helpers/localStorage'

export type ViewMode = 'grid' | 'list'

export const loadViewMode = (key: string): ViewMode => {
  return safeLocalStorage.getItem(key) === 'list' ? 'list' : 'grid'
}

export const saveViewMode = (key: string, mode: ViewMode): void => {
  safeLocalStorage.setItem(key, mode)
}
